<template>
<div class="chapter">
<div class="inner_page">
<p class="center5"><a id="page_9"><i>One thousand people are very few. In a world in which millions are dying, the statistically minded might say that it’s hardly worthwhile to save a mere 1,000 lives. What is one or what is 100 amongst a million?</i></a></p><a id="page_9">
</a><p class="center"><a id="page_9"><i>But what is one is not a statistical question if that one happens to be you. The whole fate of mankind is encompassed in a single person, and in a single person is the whole fate of mankind</i>.</a><a id="isup1"></a><span href="#/Notes#sup1" title="Link target outside of Sample"><sup>1</sup></span></p>
<p class="center1"><i>—Dorothy Thompson, introducing the radio program “Christmas in Freedom,” featuring the refugees of the Fort Ontario Emergency Shelter, December 1944</i><a id="page_10"></a></p><a id="page_10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Preface1.vue?762d2f24